/**
 * @description Reset Context
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module context/ResetContext
 */

import React from 'react';

export default React.createContext(() => null);